import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useBrandConfiguration } from '@search/core/brands/context';
import { useApis } from '@search/core/hooks/useApis';
import { useStageConfiguration } from '@search/core/hooks/useStageConfiguration';
import { useUpdateEffect } from 'react-use';
import { useAppContext } from '../../contexts/AppContext/useAppContext';
import { fetchSerpData } from '../../services/serpData';
export const useSerpData = () => {
    const { brand, pageSize, suggestionSlots = [] } = useBrandConfiguration();
    const { stage } = useStageConfiguration();
    const { bffUri } = useApis();
    const { language } = useLocale();
    const [searchModel, searchServiceModel, seoModel, order, page, setSerpData, setApiError, setIsLoading, searchEndpoints,] = useAppContext((store) => [
        store.searchModel,
        store.searchServiceModel,
        store.seoModel,
        store.order,
        store.page,
        store.setSerpData,
        store.setApiError,
        store.setIsLoading,
        store.appConfig.searchEndpoints,
    ]);
    // Retrieving the SERP data only after first rendering (data already retrieved on SSR)
    useUpdateEffect(() => {
        // we cannot use fetcher here because it is a hook
        void (async () => {
            setIsLoading(true);
            try {
                const data = await fetchSerpData({
                    searchModel,
                    searchServiceModel,
                    page,
                    pageSize,
                    order,
                    bffUri,
                    language,
                    brand,
                    stage,
                    seoModel,
                    searchEndpoints,
                    numberOfSuggestions: suggestionSlots.length,
                });
                const [searchData, pageData, linkboxes, breadcrumb, hubContent] = data;
                setSerpData({
                    ...searchData,
                    pageData,
                    linkboxes,
                    breadcrumb,
                    hubContent,
                });
            }
            catch {
                setApiError(true);
            }
            setIsLoading(false);
        })().then(() => window?.dispatchEvent(new Event('serp.update')));
    }, [searchModel, order, page]);
};
